import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as actions from '../../action';
import * as c from '../../constant';
import ViewSOAModal from '../ViewSOAModal';
import Breakdown from './Breakdown';

function TransactionTab({
  getTransactionHistoryList,
  machineryTransactionList,
  isLoading,
  historyId,
}) {
  const setModal = useContext(ModalContext);

  const handleShowBreakdown = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <Breakdown machineryTransactionList={data} />,
      title: 'Transaction Breakdown',
      modalSize: 'modal-xl',
    });
  };

  const handleViewSoa = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewSOAModal data={data} />,
      title: 'View e-SOA',
      modalSize: 'modal-xl',
    });
  };

  useEffect(() => {
    if (_.isEmpty(historyId)) return;
    getTransactionHistoryList(historyId);
  }, [historyId]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <table className="css-table table table-borderless table-sm table-striped table-hover">
                <thead className="table-header">
                  <tr>
                    <td className="font-weight-bold">TDN</td>
                    <td className="font-weight-bold">PIN</td>
                    <td className="font-weight-bold">QTR</td>
                    <td className="font-weight-bold">Year</td>
                    <td className="font-weight-bold">Amount Due</td>
                    <td />
                  </tr>
                </thead>
                <tbody>
                  {machineryTransactionList &&
                    machineryTransactionList.length <= 0 && (
                      <tr className="text-center">
                        <td className="history-color" colSpan="7">
                          No data
                        </td>
                      </tr>
                    )}
                  {machineryTransactionList &&
                    machineryTransactionList.map((item) => (
                      <tr key={item?.id}>
                        <td className="history-color">
                          {_.get(
                            item,
                            'included.machinery_application.attributes.tdn'
                          )}
                        </td>
                        <td className="history-color">
                          {_.get(
                            item,
                            'included.machinery_application.attributes.pin'
                          )}
                        </td>
                        <td className="history-color">
                          {_.get(item, 'attributes.qtr')}
                        </td>
                        <td className="history-color">
                          {_.get(item, 'attributes.year')}
                        </td>
                        <td className="history-color">
                          {_.get(item, 'attributes.amount_due')}
                        </td>
                        <td width={230}>
                          <button
                            onClick={handleShowBreakdown(item)}
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                          >
                            Breakdown
                          </button>
                          <button
                            onClick={handleViewSoa(item)}
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                          >
                            View SOA
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

TransactionTab.defaultProps = {
  historyId: '',
};

TransactionTab.propTypes = {
  getTransactionHistoryList: PropTypes.instanceOf(Function).isRequired,
  machineryTransactionList: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  historyId: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  machineryTransactionList:
    _.get(api, `${c.GET_MACHINERY_TRANSACTION_HISTORY_LIST}.list`) || [],
  isLoading:
    _.get(api, 'loading', []).indexOf(
      c.GET_MACHINERY_TRANSACTION_HISTORY_LIST
    ) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionTab);
